export const addressFragment = `
  id
  name
  firstName
  lastName
  address1
  address2
  city
  country
  zip
`
